import React from 'react';
import PropTypes from 'prop-types';
import RaisedButton from 'material-ui/RaisedButton';

import Paper from 'material-ui/Paper';
import CircularProgress from 'material-ui/CircularProgress';

import axios from 'axios';
import {Toolbar, ToolbarGroup, ToolbarSeparator, ToolbarTitle} from 'material-ui/Toolbar';
import {
    Table,
    TableBody,
    TableHeader,
    TableHeaderColumn,
    TableRow,
    TableRowColumn,
} from 'material-ui/Table';
import Toggle from 'material-ui/Toggle';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import Chip from 'material-ui/Chip';

import {fullBlack} from 'material-ui/styles/colors';
import ActionRight from 'material-ui/svg-icons/av/fast-forward';
import ActionLeft from 'material-ui/svg-icons/av/fast-rewind';

import _ from "underscore";

axios.defaults.headers.common['Authorization'] = "Basic YWRtaW46YWRtaW4=";


export default class FilterTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            open: false,

            filters_active: [],
            filters_allowed: [],

            values:[]
        };

        this.handleOnChangeSelect           = this.handleOnChangeSelect.bind(this);
        this.handleChange                   = this.handleChange.bind(this);
        this.handleSave                     = this.handleSave.bind(this);
        this.skipSavingMapping              = this.skipSavingMapping.bind(this);
        this.wasLoaded                      = this.wasLoaded.bind(this);
    }

    componentDidMount() {
        const self = this;

        return axios.get(`/api/seller/${this.props.seller_id}/filter-data`)
            .then(response => {
                self.setState({
                    loading: false,
                    filters_active: response.data.content['active'],
                    filters_allowed: response.data.content['allowed']
                });
            }).catch(function () {
                self.setState({
                    loading: false
                });
            });
    }

    _getEntityIndexByName(name) {
        let entityPosition = -1;

        _.each(this.state.filters_active, function (element, index) {
            if(element.filter === name) entityPosition = index;
        }, this);

        return entityPosition;
    }

    handleOnChangeSelect(rowData, event, index, selectedValue) {
        selectedValue = _.isArray(selectedValue) ? selectedValue[0] : selectedValue;

        this.handleOnChange(rowData, event,  selectedValue);
    }

    handleOnChange(rowData, event, value) {
        const filters_active = this.state.filters_active;
        const entityPosition = this._getEntityIndexByName(rowData.name);
        let entity;

        value = _.isUndefined(value) ? event.target.value : value;
        value = (rowData.type === "multiselect") ? this.convertValueIfMultiselect(value, rowData.name) : value;
        value = _.isArray(value) ? value : [value];
        if(_.isArray(value) && value.length === 1 && _.isNull(value[0])) value = null;

        if(entityPosition === -1) {
            entity = {
                'filter': rowData.name,
                'values': value
            };

            filters_active.push(entity);
        } else {
            entity = filters_active[entityPosition];
            entity['values'] = value;

            filters_active[entityPosition] = entity;
        }

        this.setState({
            'filters_active': filters_active
        });

    }

    multiSelectIsContainsValue(selectedValue, filterName) {
        const entityPosition = this._getEntityIndexByName(filterName);
        const existedSelection = entityPosition === -1 ? [] : (_.isArray(this.state.filters_active[entityPosition]['values']) ? this.state.filters_active[entityPosition]['values'] : []) ;
        return _.contains(existedSelection, selectedValue);
    }

    convertValueIfMultiselect(selectedValue, filterName) {
        const entityPosition = this._getEntityIndexByName(filterName);
        const existedSelection = entityPosition === -1 ? [] : (_.isArray(this.state.filters_active[entityPosition]['values']) ? this.state.filters_active[entityPosition]['values'] : []) ;

        if(_.contains(existedSelection, selectedValue)) {
            const t = _.without(existedSelection, selectedValue);
            return t.length === 0 ? null : t;
        } else {
            existedSelection.push(selectedValue);
            return existedSelection;
        }
    }

    handleSave() {
        const self = this;

        const filters = {
            'active': this.state.filters_active
        };

        this.setState({
            loading: true
        });

        axios.put(`/api/seller/${this.props.seller_id}/filter-data`, {
            filters: filters
        }).then(function (response) {
            self.wasLoaded(response);

            self.props.handleSave();
        }).catch(self.wasLoaded);
    }

    wasLoaded (response) {
        this.setState({
            loading: false
        });

    }

    skipSavingMapping() {
        this.props.handleSave();
    }

    handleChange(event, index, values) {
        this.setState({
            values: values
        });
    }

    getRowValueContent(rowData) {
        const key = Math.random() + "A";
        const self = this;
        const entity = _.findWhere(this.state.filters_active, {'filter': rowData.name});
        const value = _.isObject(entity) ? (_.isArray(entity['values']) ? entity['values'][0] : null) : entity;


        switch(rowData.type) {
            case "text":
                return <TextField  defaultValue={value} id={key} onChange={this.handleOnChange.bind(this, rowData)} />;
            case "multiselect":
                const selectorsMultiple = rowData.options.map(function (e) {
                    return <MenuItem insetChildren checked={self.multiSelectIsContainsValue(e.id, rowData.name)} key={e.id} value={e.id} primaryText={e.value} />
                });

                const selectorsChips = [];
                _.each(rowData.options, function (e) {
                    if(this.multiSelectIsContainsValue(e.id, rowData.name)) {
                        selectorsChips.push(<Chip key={e.id} style={{margin: 4}}>{e.value}</Chip>);
                    }
                }, this);

                return  <div>
                          {selectorsChips}
                          <SelectField multiple hintText={rowData.name} onChange={this.handleOnChangeSelect.bind(this, rowData)}>{selectorsMultiple}</SelectField>
                        </div>;
            case "select":
                const selectors = rowData.options.map(function (e) {
                    return <MenuItem key={e.id} value={e.id} primaryText={e.value} />
                });

                return <SelectField value={value} hintText={rowData.name} onChange={this.handleOnChangeSelect.bind(this, rowData)}>{selectors}</SelectField>;
            case "boolean":
                return <Toggle toggled={value === true} id={key} style={{marginBottom: 25}} onToggle={this.handleOnChange.bind(this, rowData)} />;
            case "integer":
            case "int":
                return <input style={{width: '100px', height: '20px'}} id={key} value={value} onChange={this.handleOnChange.bind(this, rowData)} type='number' step='1' min={Math.min(...rowData.options)} max={Math.max(...rowData.options)} />;
            default:
                return <div id={key}>Unsupported filter type</div>
        }
    }

    render() {
        return this.state.loading ? <CircularProgress size={80} thickness={5} /> : this.table();
    }

    table() {
        const self = this;
        const tableBody = this.state.filters_allowed.map(function(row) {
            return (
                <TableRow key={Math.random() + "A"}>
                    <TableRowColumn><span>{row.label}</span></TableRowColumn>
                    <TableRowColumn>{self.getRowValueContent(row)}</TableRowColumn>
                </TableRow>);
        });

        return (
            <Paper>
                {this.getControlBtns()}

                <Table>
                    <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                        <TableRow>
                            <TableHeaderColumn tooltip="Filter label">Filter</TableHeaderColumn>
                            <TableHeaderColumn tooltip="Value">Value</TableHeaderColumn>
                        </TableRow>
                    </TableHeader>
                    <TableBody displayRowCheckbox={false}>
                        {tableBody}
                    </TableBody>
                </Table>

            </Paper>
        )
    }

    getControlBtns() {
        return (
            <Toolbar>
                <ToolbarGroup firstChild={true}>
                </ToolbarGroup>
                <ToolbarGroup>
                    <ToolbarTitle text="Filter" />
                    <ToolbarSeparator />

                    <RaisedButton
                        icon={<ActionLeft color={fullBlack} />}
                        onClick={this.props.handlePrev}
                    />

                    <RaisedButton
                        primary
                        label="Save and next"
                        onClick={this.handleSave}
                        style={{marginRight: 12}}
                    />

                    <RaisedButton
                        icon={<ActionRight color={fullBlack} />}
                        onClick={this.skipSavingMapping}
                        style={{marginRight: 12}}
                    />
                </ToolbarGroup>

            </Toolbar>
        );
    }

}

FilterTable.propTypes = {
    erp_id: PropTypes.number.isRequired,
    seller_id: PropTypes.number.isRequired,
    handleSave: PropTypes.func.isRequired,
    handlePrev: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./assets/src/js/FilterTable.jsx